<template>
  <div class="layer">
    <div class="inner">
      <div>
        <select class="input inlineInput" v-model="time.from.hh">
          <option v-for="hh in timeSlot().hour" :key="hh" :value="hh">{{hh}}</option>
        </select>
        :
        <select class="input inlineInput" v-model="time.from.mm">
          <option v-for="mm in timeSlot().minute" :key="mm" :value="mm">{{mm}}</option>
        </select>
        <span class="sp">-</span>
        <select class="input inlineInput" v-model="time.to.hh">
          <option v-for="hh in timeSlot().hour" :key="hh" :value="hh">{{hh}}</option>
        </select>
        :
        <select class="input inlineInput" v-model="time.to.mm">
          <option v-for="mm in timeSlot().minute" :key="mm" :value="mm">{{mm}}</option>
        </select>
      </div>
      <p v-if="!validate" class="colorRed mt5">ⓘ {{locale.message_available_endtime}}</p>
      <div class="btns mt15">
        <button type="button" class="btn btnWhite mr15" @click="onClose">{{locale.cancel}}</button>
        <button type="button" class="btn btnPrimary" :disabled="!validate" @click="apply">{{add ? locale.add : locale.modify}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvailableTimeEdit',
  props: [
    'locale',
    'timeInfo'
  ],
  computed: {
    add () {
      return !this.timeInfo
    },
    validate () {
      const from = this.timeToNum(this.time.from)
      const to = this.timeToNum(this.time.to)
      return from < to
    }
  },
  created () {
    if (this.timeInfo) {
      this.time = {
        from: this.getTime(this.timeInfo.from),
        to: this.getTime(this.timeInfo.to)
      }
    }
  },
  data () {
    return {
      time: {
        from: {
          hh: '00',
          mm: '00'
        },
        to: {
          hh: '24',
          mm: '00'
        }
      }
    }
  },
  methods: {
    timeToNum (time) { // time: {hh: '00', mm: '00'}
      const times = time.hh + time.mm
      return parseInt(times)
    },
    timeSlot () {
      let hour = []
      let minute = []
      for (let i = 0; i <= 24; i++) {
        hour.push(`${('0' + i).slice(-2)}`)
      }
      for (let i = 0; i <= 5; i++) {
        minute.push(`${('0' + i * 10).slice(-2)}`)
      }
      return {
        hour: hour,
        minute: minute
      }
    },
    getTime (time) {
      return {
        hh: time.split(':')[0],
        mm: time.split(':')[1]
      }
    },
    apply () {
      if (window.confirm(this.add ? this.locale.confirm_add : this.locale.confirm_modify)) {
        const time = {
          from: `${this.time.from.hh}:${this.time.from.mm}`,
          to: `${this.time.to.hh}:${this.time.to.mm}`
        }
        this.$emit('apply', time)
      }
    },
    onClose () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .inner {
  max-width: 400px;
  align-items: center;
  border-radius: 20px;
}
.sp {
  margin-left: 15px;
  margin-right: 15px;
}
</style>
